import { Injectable } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { PhotoConfirmPage } from '../pages/_com/photo-confirm/photo-confirm';
import { LoadingService } from '../providers/loading-service';
import { Subject } from 'rxjs/Subject';
import { ImagePicker } from '@ionic-native/image-picker';

/**
 * Generated class for the FamilyPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Injectable()
export class PhotoAction {
  constructor(
    private camera:Camera,
    private modalController:ModalController,
    private loadingService:LoadingService,
    private imagePicker: ImagePicker,
  ) {
  }

  /**
   * 20180402: 写真撮影したデータをsubscribeで監視していると複数回登録される問題対応
   * 写真を登録した歳に、複数のページで「captureData$」がsubscribeされており、その結果複数枚データが登録される問題が発生した。
   * 
   * 正しい対応としては、Promiseに処理を変更するか、Providerをそもそもシングルトンクラスではなく、
   * 撮影した写真クラス毎にインスタンスを生成するなどして対応したほうが良さそうであるが変更箇所も多いので、
   * もともと存在していたPhotoActionをnewして別のインスタンスを返すようにし、
   * 既存の処理への影響を極力少なくする形で対応を実施する。
   */
  getInstance():_PhotoAction {
    return new _PhotoAction(this.camera, this.modalController, this.loadingService, this.imagePicker);
  }

}

export class _PhotoAction {

  camera:Camera;
  modalController:ModalController;
  loadingService:LoadingService;
  imagePicker: ImagePicker;

  constructor(
    camera:Camera,
    modalController:ModalController,
    loadingService:LoadingService,
    imagePicker: ImagePicker,
  ) {
    this.camera = camera;
    this.modalController = modalController;
    this.loadingService = loadingService;
    this.imagePicker = imagePicker;
  }

  /**
   * 写真撮影
   */
  private capture_ = new Subject<string>();
  public captureData$ = this.capture_.asObservable();

  /**
   * 写真選択（複数選択）
   */
  private captures_ = new Subject<any>();
  public captureDatas$ = this.captures_.asObservable();

  private screen = "";

  getScreen(){
    return this.screen;
  }

  /**
   *  カメラ撮影
   */
  takeCamera(userOption:{needModal:boolean, screen:string} = {needModal:true, screen:""}) {

    this.screen = userOption.screen;

    const options: CameraOptions = {
      quality: 50,
      // destinationType: this.camera.DestinationType.NATIVE_URI,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      targetWidth: 900,
      targetHeight: 1200,
      correctOrientation:true,
      saveToPhotoAlbum: true,
    }
    this.activatePhotoProcess(options, userOption);
  }

  /**
   * 写真選択（１枚選択）
   * @param userOption
   */
  photoSelectSingle(userOption: { needModal: boolean, screen: string } = { needModal: true, screen: "" }){

    this.screen = userOption.screen;

    const options: CameraOptions = {
      quality: 50,
      // destinationType: this.camera.DestinationType.NATIVE_URI,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      targetWidth: 900,
      targetHeight: 1200,
      correctOrientation: true,
      saveToPhotoAlbum: false,
      sourceType:0,
    }
    this.activatePhotoProcess(options, userOption);
  }

  /**
   * 写真選択（複数選択）
   */
  photoSelectMultiple(userOption:{needModal:boolean, screen:string} = {needModal:true, screen:""}) {

    this.screen = userOption.screen;
    var self = this;

    this.imagePicker.getPictures({maximumImagesCount:10, outputType:1, quality:10}).then((results) => {
      var list = [];
      for (var i = 0; i < results.length; i++) {
        list.push("data:image/jpeg;base64," +  results[i]);
      }
      self.captures_.next(list);
    }, (err) => { });
  }

  /**
   * ネイティブのカメラ処理・写真選択を起動する
   */
  activatePhotoProcess(options: CameraOptions, userOption:{needModal:boolean}){

    this.camera.getPicture(options).then((imageData)=>{

      imageData = "data:image/jpeg;base64," + imageData;

      if(userOption.needModal){
        //モーダル表示後に保存有無を判定
        var profileModal = this.modalController.create(PhotoConfirmPage, {imageData:imageData});
        profileModal.present();
        this.loadingService.present("");
        profileModal.onDidDismiss(data => {
          //画像保存が必要化判定
          if(data["isSave"]){
            this.capture_.next(imageData);
          }
        });        
      } else {
        //モーダル表示無しで画像データを戻す
        this.capture_.next(imageData);
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/photo.action.ts